import en from "./dictionares/en.json";
import sk from "./dictionares/sk.json";
import cs from "./dictionares/cs.json";
import de from "./dictionares/de.json";
import bg from "./dictionares/bg.json";
import zh from "./dictionares/zh.json";
import da from "./dictionares/da.json";
import no from "./dictionares/no.json";
import nl from "./dictionares/nl.json";
import et from "./dictionares/et.json";
import fi from "./dictionares/fi.json";
import fr from "./dictionares/fr.json";
import el from "./dictionares/el.json";
import hu from "./dictionares/hu.json";
import id from "./dictionares/id.json";
import it from "./dictionares/it.json";
import ja from "./dictionares/ja.json";
import ko from "./dictionares/ko.json";
import lv from "./dictionares/lv.json";
import lt from "./dictionares/lt.json";
import pl from "./dictionares/pl.json";
import pt from "./dictionares/pt.json";
import ro from "./dictionares/ro.json";
import ru from "./dictionares/ru.json";
import sl from "./dictionares/sl.json";
import es from "./dictionares/es.json";
import sv from "./dictionares/sv.json";
import tr from "./dictionares/tr.json";
import uk from "./dictionares/uk.json";

export const defaultLocale = 'en'

export const langTexts = {
    en: en.txts,
    sk: sk.txts,
    cs: cs.txts,
    de: de.txts,
    bg: bg.txts,
    zh: zh.txts,
    da: da.txts,
    nl: nl.txts,
    et: et.txts,
    fi: fi.txts,
    fr: fr.txts,
    el: el.txts,
    hu: hu.txts,
    id: id.txts,
    it: it.txts,
    ja: ja.txts,
    ko: ko.txts,
    lv: lv.txts,
    lt: lt.txts,
    pl: pl.txts,
    pt: pt.txts,
    ro: ro.txts,
    ru: ru.txts,
    sl: sl.txts,
    es: es.txts,
    sv: sv.txts,
    tr: tr.txts,
    uk: uk.txts,
    no: no.txts,
}


export const langs = {
    en: en.type,
    sk: sk.type,
    cs: cs.type,
    de: de.type,
    bg: bg.type,
    zh: zh.type,
    da: da.type,
    nl: nl.type,
    et: et.type,
    fi: fi.type,
    fr: fr.type,
    el: el.type,
    hu: hu.type,
    id: id.type,
    it: it.type,
    ja: ja.type,
    ko: ko.type,
    lv: lv.type,
    lt: lt.type,
    pl: pl.type,
    pt: pt.type,
    ro: ro.type,
    ru: ru.type,
    sl: sl.type,
    es: es.type,
    sv: sv.type,
    tr: tr.type,
    uk: uk.type,
    no: no.type
}

export const countries = [
    'en-gb',
    'sk',
    'cs'
]
